import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { graphqlService } from '../services/graphqlService';

const categories = [
  'General',
  'TruMerit'
];

const PrescreeningCategory = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleBack = () => {
    navigate('/prescreening/level');
  };

  const handleNext = async () => {
    if (selectedCategory && user && user.email) {
      try {
        // Get existing prescreening data
        let existingData = {};
        try {
          const prescreening = await graphqlService.getPrescreening(user.email);
          if (prescreening) {
            existingData = prescreening;
          }
        } catch (error) {
          // No existing data, start fresh
        }

        // Update prescreening data
        await graphqlService.createOrUpdatePrescreening({
          userEmail: user.email,
          ...existingData,
          category: selectedCategory
        });
        
        navigate('/prescreening/tags');
      } catch (error) {
        console.error('Error saving prescreening data:', error);
        alert('Failed to save data. Please try again.');
      }
    }
  };

  return (
    <div className="prescreening-container">
      <div className="prescreening-header">
        <button className="back-btn" onClick={handleBack}>
          <ArrowLeft size={20} />
          Back
        </button>
        <h1 className="prescreening-title">Choose Your Category</h1>
      </div>

      <div className="prescreening-progress">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: '66%' }}></div>
        </div>
      </div>

      <div className="prescreening-content">
        <h2 className="prescreening-question">What category type are you interested in?</h2>
        
        <div className="goal-options">
          {categories.map((category) => (
            <button
              key={category}
              className={`goal-card ${selectedCategory === category ? 'selected' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="prescreening-actions">
          <button 
            className="prescreening-next-btn"
            onClick={handleNext}
            disabled={!selectedCategory}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrescreeningCategory;

